import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFirewall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFirewall"><Path d="M12 3.5H3.5V9M12 3.5V9M12 3.5H20.5V9M12 9H3.5M12 9H20.5M3.5 9H7.5M3.5 9V15M20.5 9H16.5M20.5 9V15M3.5 15H12M3.5 15V20.5H12M3.5 15H7.5M12 15V20.5M12 15H20.5M12 20.5H20.5V15M20.5 15H16.5M16.5 9V15M16.5 9H7.5M16.5 15H7.5M7.5 9V15" stroke="currentColor"/></CentralIconBase>;
});

export default IconFirewall;
